export const siteConfig = {
    appName: 'AZ Strategy - Payment Portal',
    metaDescription: 'Secure payment portal',
    faviconUrl: 'https://azstrategy.com/wp-content/uploads/2022/11/cropped-final-logo-transparent-01.png',
    brandLogoUrl: 'https://azstrategy.com/wp-content/uploads/Email-Signature-Logo.png',


    brandColors: {
        primary: '#221066',
        primaryHover: '#1A0C4D',
        secondary: '#F69A35',
        buttonText: '#FFFFFF',
    },

    footer: {
        name: 'AZ Strategy LLC',
        termsOfServiceLabel: 'Terms of Service',
        termsOfServiceUrl: 'https://azstrategy.com/terms-of-service/',
        privacyPolicyLabel: 'Privacy Policy',
        privacyPolicyUrl: 'https://azstrategy.com/privacy-policy/',
    },

    paymentSucceededPagePath: '/success',
    setupSucceededPagePath: '/setup-success',
    paymentSucceededPageRedirectLink: '/',
};
